import { createElement } from 'react'
import { createRoot } from 'react-dom/client'
import FeedApp from '@/components/FeedApp'

function mount() {
  const container = document.getElementById('react-feed-root')
  if (container) {
    const props = JSON.parse(container.dataset.props || '{}')
    const root = createRoot(container)
    root.render(createElement(FeedApp, props))
  }
}

// Turbo Drive replaces the body on navigation without firing DOMContentLoaded.
// Listen for turbo:load which fires on both initial load and Turbo navigations.
document.addEventListener('turbo:load', mount)
